export const EmptyCreateTicketArticleFormData = {
    body: ""
}

export interface IEmptyCreateTicketArticleFormData{
    body: string 
}
